// ============================================================
// HGO SERVICIOS — Datos centrales del negocio (NAP + contenido)
// Editar aquí = actualizar en todo el sitio (incl. schemas)
// ============================================================

export const SITE = {
  name: 'HGO Servicios',
  legalName: 'HGO Servicios S.L.',
  domain: 'https://hgoservicios.com',
  phone: '+34643670832',
  phoneDisplay: '+34 643 67 08 32',
  whatsapp: '34643670832',
  email: 'info@hgoservicios.com',
  founder: 'Hugo Caballero',
  city: 'Málaga',
  region: 'Andalucía',
  country: 'ES',
  hours: 'Lunes a viernes · 9:00 – 18:00',
  founded: 2009,
  rating: '4.9',
  reviewCount: '87',
  priceRange: '€€',
  lat: 36.721261,
  lng: -4.421266,
  social: {
    facebook: 'https://www.facebook.com/hgoservicios',
    instagram: 'https://www.instagram.com/hgoservicios',
  },
};

export const ZONES = [
  { name: 'Málaga Capital', slug: 'malaga' },
  { name: 'Marbella', slug: 'marbella' },
  { name: 'Torremolinos', slug: 'torremolinos' },
  { name: 'Benalmádena', slug: 'benalmadena' },
  { name: 'Fuengirola', slug: 'fuengirola' },
  { name: 'Estepona', slug: 'estepona' },
  { name: 'Rincón de la Victoria', slug: 'rincon-de-la-victoria' },
  { name: 'Vélez-Málaga', slug: 'velez-malaga' },
  { name: 'Mijas', slug: 'mijas' },
  { name: 'Nerja', slug: 'nerja' },
];

// Fotos reales de proyectos (public/fotos-webp)
export const PROJECTS = [
  {
    id: '01',
    title: 'Reforma integral de vivienda',
    type: 'Reforma integral',
    location: 'Málaga Capital',
    year: '2025',
    image: '/fotos-webp/5678.webp',
    description: 'Reforma integral completa: cocina, baños, carpintería y acabados premium.',
  },
  {
    id: '02',
    title: 'Rehabilitación de fachada',
    type: 'Rehabilitación',
    location: 'Centro histórico de Málaga',
    year: '2025',
    image: '/fotos-webp/567.webp',
    description: 'Rehabilitación de fachada con recuperación de elementos originales.',
  },
  {
    id: '03',
    title: 'Local comercial llave en mano',
    type: 'Reforma comercial',
    location: 'Marbella',
    year: '2024',
    image: '/fotos-webp/8f6fefcf-87f7-4f9f-a818-2857a35314f6.webp',
    description: 'Adecuación de local comercial: instalaciones, iluminación y acabados.',
  },
  {
    id: '04',
    title: 'Reforma de baño y cocina',
    type: 'Reforma parcial',
    location: 'Torremolinos',
    year: '2024',
    image: '/fotos-webp/ac3b6353-ea93-4f95-97d2-baea07c2ad96.webp',
    description: 'Reforma integral de baño y cocina con plomería y electricidad nueva.',
  },
  {
    id: '05',
    title: 'Obra nueva de vivienda unifamiliar',
    type: 'Obra nueva',
    location: 'Benalmádena',
    year: '2024',
    image: '/fotos-webp/9d864621-c4cb-43a9-a018-57f97bbdcd0b.webp',
    description: 'Construcción de vivienda unifamiliar desde cimentación hasta llaves.',
  },
  {
    id: '06',
    title: 'Reforma de comunidad de propietarios',
    type: 'Mantenimiento',
    location: 'Fuengirola',
    year: '2023',
    image: '/fotos-webp/56798.webp',
    description: 'Reforma de zonas comunes, portal y escaleras de comunidad.',
  },
  {
    id: '07',
    title: 'Reforma integral de piso',
    type: 'Reforma integral',
    location: 'Rincón de la Victoria',
    year: '2023',
    image: '/fotos-webp/2fd2299b-b4e7-4384-93c4-54581f9023e2.webp',
    description: 'Distribución nueva, suelos técnicos e instalaciones renovadas.',
  },
  {
    id: '08',
    title: 'Reforma de vivienda en planta baja',
    type: 'Reforma integral',
    location: 'Vélez-Málaga',
    year: '2023',
    image: '/fotos-webp/8e5fc6d5-e0d1-4e38-84c8-7e3de32b0f12.webp',
    description: 'Reforma integral con patio: albañilería, instalaciones y acabados.',
  },
];

export const GALLERY_PHOTOS = [
  '/fotos-webp/5678.webp',
  '/fotos-webp/567.webp',
  '/fotos-webp/8f6fefcf-87f7-4f9f-a818-2857a35314f6.webp',
  '/fotos-webp/ac3b6353-ea93-4f95-97d2-baea07c2ad96.webp',
  '/fotos-webp/9d864621-c4cb-43a9-a018-57f97bbdcd0b.webp',
  '/fotos-webp/56798.webp',
  '/fotos-webp/2fd2299b-b4e7-4384-93c4-54581f9023e2.webp',
  '/fotos-webp/8e5fc6d5-e0d1-4e38-84c8-7e3de32b0f12.webp',
  '/fotos-webp/4a1590e1-d202-4156-b516-f17835237975.webp',
  '/fotos-webp/2859b078-b5c6-47ae-b1bb-89354156c4aa.webp',
  '/fotos-webp/3c13b027-09ea-49ae-91fe-0cc25552f504.webp',
  '/fotos-webp/2.webp',
  '/fotos-webp/1.webp',
  '/fotos-webp/121.webp',
  '/fotos-webp/IMG_4377.webp',
  '/fotos-webp/2b7b8a45-43ba-43ef-9e7e-c3d07ffbc68c.webp',
  '/fotos-webp/0ac34ed1-8f26-4a6d-936c-6722d113ded9.webp',
  '/fotos-webp/843edc46-8d4e-40f2-b50a-57f57908c0a0.webp',
  '/fotos-webp/3d5fdfe7-193f-4100-9558-ee9c725a06a8.webp',
  '/fotos-webp/8e0c139d-a353-4328-97f2-cce756d188a9.webp',
  '/fotos-webp/8e13300d-4cb9-4926-87f7-f7c156cba8f8.webp',
  '/fotos-webp/4.webp',
  '/fotos-webp/3.webp',
  '/fotos-webp/7ab346be-0ebf-444f-afdf-34d480a7b660.webp',
  '/fotos-webp/23b0c526-5fee-4e13-b10a-5f1b963b127a.webp',
  '/fotos-webp/19debdb3-795e-4ec2-b7cd-7af578bbc342.webp',
  '/fotos-webp/3d8775ca-f357-4733-9c8d-2fbf766bff23.webp',
  '/fotos-webp/8e037994-626b-477e-983c-881d03d2cbfd.webp',
];

export const STATS = [
  { value: 150, suffix: '+', label: 'Proyectos entregados' },
  { value: 15, suffix: '+', label: 'Años de experiencia' },
  { value: 98, suffix: '%', label: 'Clientes satisfechos' },
  { value: 24, suffix: 'h', label: 'Respuesta a tu presupuesto' },
];

export const SERVICES = [
  {
    slug: 'reformas-integrales',
    title: 'Reformas integrales',
    short: 'Transformación completa de viviendas: distribución, instalaciones y acabados, llave en mano.',
    index: '01',
  },
  {
    slug: 'obra-nueva',
    title: 'Obra nueva',
    short: 'Construcción de viviendas unifamiliares desde la cimentación hasta la entrega de llaves.',
    index: '02',
  },
  {
    slug: 'reformas-comerciales',
    title: 'Reformas comerciales',
    short: 'Adecuación de locales, oficinas y espacios comerciales para que tu negocio abra a tiempo.',
    index: '03',
  },
  {
    slug: 'rehabilitacion',
    title: 'Rehabilitación',
    short: 'Recuperación estructural y eficiencia energética de edificios y fachadas.',
    index: '04',
  },
  {
    slug: 'mantenimiento',
    title: 'Mantenimiento y comunidades',
    short: 'Mantenimiento integral y reformas para comunidades de propietarios.',
    index: '05',
  },
];

export const PROCESS = [
  {
    step: '01',
    title: 'Visita y presupuesto',
    text: 'Vamos a tu vivienda o local, medimos, escuchamos tus necesidades y te entregamos un presupuesto detallado y sin compromiso en 24–48h.',
  },
  {
    step: '02',
    title: 'Planificación',
    text: 'Te asesoramos sobre materiales, distribución y plazos. Planificamos la obra al día, coordinando oficios y proveedores.',
  },
  {
    step: '03',
    title: 'Ejecución',
    text: 'Ejecutamos con equipos propios y certificados, cuidando cada detalle. Trabajo limpio y comunicaciones diarias de avance.',
  },
  {
    step: '04',
    title: 'Entrega y garantía',
    text: 'Entregamos con limpieza final, documentación y garantía por escrito. Nada queda a medias: revisamos contigo cada espacio.',
  },
];

export const TESTIMONIALS = [
  {
    name: 'María G.',
    project: 'Reforma integral · Málaga Capital',
    text: 'Reformaron toda la casa en 10 semanas, justo lo que prometieron. El trato fue cercano y el resultado, espectacular. Lo recomiendo sin dudarlo.',
  },
  {
    name: 'Javier R.',
    project: 'Local comercial · Marbella',
    text: 'Abrimos el negocio puntual porque cumplieron cada plazo. Presupuesto cerrado sin sorpresas: lo que firmamos fue lo que pagamos.',
  },
  {
    name: 'Carmen L.',
    project: 'Reforma de baño y cocina · Torremolinos',
    text: 'Trabajaron en casa mientras vivíamos en ella y mantuvieron todo limpio y ordenado. Acabados muy cuidados y consejos de material excelentes.',
  },
  {
    name: 'Antonio M.',
    project: 'Rehabilitación de fachada · Centro de Málaga',
    text: 'Tramitaron los permisos municipales por nosotros y gestionaron la comunidad entera. Profesionales de principio a fin.',
  },
];

export const FAQS = [
  {
    q: '¿Cuánto cuesta una reforma integral en Málaga?',
    a: 'Depende de la superficie, el estado de la vivienda y la calidad de los acabados. Como referencia orientativa, una reforma integral ronda entre 500 € y 900 € por m². El primer paso es una visita gratuita: medimos, valoramos y te damos un presupuesto cerrado en 24–48 horas, sin compromiso.',
  },
  {
    q: '¿Cuánto dura una reforma integral?',
    a: 'Una reforma integral de una vivienda de 80–100 m² suele durar entre 8 y 12 semanas. En la planificación inicial te entregamos un calendario por fases y vamos actualizándolo cada semana. Cumplir plazos es parte de nuestro compromiso escrito.',
  },
  {
    q: '¿El presupuesto es gratuito?',
    a: 'Sí, la visita y el presupuesto son totalmente gratuitos y sin compromiso. Te detallamos cada partida para que sepas exactamente qué incluye y qué no, y respondemos en un máximo de 24–48 horas laborables.',
  },
  {
    q: '¿Trabajáis en toda la provincia de Málaga?',
    a: 'Sí. Cubrimos Málaga capital y toda la Costa del Sol: Marbella, Torremolinos, Benalmádena, Fuengirola, Mijas, Estepona, Rincón de la Victoria, Vélez-Málaga y Nerja, entre otras localidades.',
  },
  {
    q: '¿Ofrecéis garantía por escrito?',
    a: 'Sí. Todos nuestros trabajos incluyen garantía por escrito. La garantía de obra es de 1 año mínima y extendemos coberturas adicionales en instalaciones y acabados. Además, trabajamos con los seguros de responsabilidad civil en vigor.',
  },
  {
    q: '¿Puedo vivir en mi casa durante la reforma?',
    a: 'En la mayoría de las reformas parciales sí, coordinamos las fases para que puedas seguir en casa. En reformas integrales muy profundas a veces es más cómodo no convivir con la obra; te asesoramos según tu caso concreto.',
  },
  {
    q: '¿Quién se encarga de los permisos y licencias?',
    a: 'Nosotros. Gestionamos la licencia de obras municipal, la notificación de obra y cualquier certificado necesario (instalaciones, final de obra). Nos encargamos de toda la burocracia para que tú solo te ocupes de disfrutar el resultado.',
  },
  {
    q: '¿Hacéis también reformas parciales?',
    a: 'Sí: baños, cocinas, pintura, suelos, carpintería, electricidad, fontanería y mantenimiento en general. Si no necesitas una reforma integral, también somos tu empresa de confianza para la obra que sea.',
  },
];

export const NAV_LINKS = [
  { label: 'Inicio', href: '/' },
  { label: 'Servicios', href: '/#servicios' },
  { label: 'Proyectos', href: '/#proyectos' },
  { label: 'Nosotros', href: '/nosotros' },
  { label: 'FAQ', href: '/faq' },
  { label: 'Contacto', href: '/contacto' },
];

export const WHATSAPP_LINK = (message: string) =>
  `https://wa.me/${SITE.whatsapp}?text=${encodeURIComponent(message)}`;
